import TextField from "@mui/material/TextField";

import WebService from "../util/webService";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import { getRandomInt, printVariable, searchSchool } from "../util/helper";
import {
  Button,
  ButtonGroup,
  FormControl,
  InputLabel,
  Menu,
  Typography,
} from "@mui/material";
import useDelegate from "@hooks/useDelegate";
import { Fragment, useEffect, useMemo, useRef, useState, forwardRef, useImperativeHandle  } from "react";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FlatButton from "@components/FlatButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { makeStyles } from "@mui/styles";
import Select from "@mui/material/Select";
import useIndicator from "@hooks/useIndicator"
import Indicator from "@components/Indicator";
import useAlert from '@hooks/useAlert'
import useSnackbar from '@hooks/useSnackbar';
import Dialog from '@mui/material/Dialog';
import ConfirmDialog from "@components/ConfirmDialog";
import { detectBrowser } from "@util/helper";
import { useParams, useLocation } from 'react-router-dom'


const CachePage = () => {
  const { cacheName, key } = useParams()
  const { alert, renderAlert } = useAlert()

  const clearCache = async(cacheName, key) => {
    if(cacheName  && key) {
      const url = `/cache/clear/${cacheName}/${key}`
      const resp = await WebService.post(url, {})
      if(resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }
      alert('Cache cleared')
    }
  }

  useEffect(() => {
    console.log('cacheName=>', cacheName)
    console.log('key=>', key)
    clearCache(cacheName, key)
  }, [cacheName, key])

  return (
    <div>
      <h1>Cache Page</h1>
      <h2>cacheName: {cacheName}</h2>
      <h2>key: {key}</h2>
      {renderAlert()}
    </div>
  )
}

export default CachePage